import { useInView } from "react-intersection-observer";

export const useScroll = (threshold: number) => {
  const { ref, inView } = useInView({ threshold: threshold });
  return { ref, inView };
};
